(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pc-duo-followup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',function(event){
  const form=event.target.closest('[data-pc-duo]');
  if(!form||!event.target.matches('[data-pc-duo-select]'))return;
  const fields=Array.from(form.querySelectorAll('[data-pc-duo-select]'));
  const chosen=fields.map(field=>field.selectedOptions[0]);
  const ready=chosen.length===2&&chosen.every(option=>option&&option.value);
  const button=form.querySelector('[data-pc-duo-submit]');
  const total=form.querySelector('[data-pc-duo-total]');
  button.disabled=!ready;
  if(ready){
    const cents=chosen.reduce((sum,option)=>sum+Number(option.dataset.price||0),0);
    total.textContent=new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{style:'currency',currency:form.dataset.currency||'EUR'}).format(cents/100);
  }else{
    total.textContent=form.dataset.placeholder;
  }
  form.querySelector('[data-pc-duo-status]').textContent='';
});
document.addEventListener('submit',async function(event){
  const form=event.target.closest('[data-pc-duo]');
  if(!form)return;
  event.preventDefault();
  const fields=Array.from(form.querySelectorAll('[data-pc-duo-select]'));
  if(fields.length!==2||fields.some(field=>!field.value))return;
  const count=new Map();
  fields.forEach(field=>count.set(field.value,(count.get(field.value)||0)+1));
  const items=Array.from(count,entry=>({id:Number(entry[0]),quantity:entry[1]}));
  const button=form.querySelector('[data-pc-duo-submit]');
  const status=form.querySelector('[data-pc-duo-status]');
  const original=button.textContent;
  const root=form.dataset.root||'/';
  button.disabled=true;
  button.textContent=form.dataset.pending;
  status.textContent='';
  try{
    const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',body:JSON.stringify({items})});
    if(!response.ok)throw new Error('cart');
    window.location.assign(root+'cart');
  }catch(error){
    status.textContent=form.dataset.error;
    button.textContent=original;
    button.disabled=false;
  }
});

/* Préselection non nominative depuis les liens Judge.me / Shopify Flow.
   Exemple : ?pc_pref1=patagonia-ouro-preto&pc_pref2=signature-tierra-suave#mon-prefere */
(function () {
  const permitted = ['sol-andino-sierra-alta','signature-tierra-suave','patagonia-ouro-preto','espresso-brasa-morena'];
  function applyCoffeePreferences() {
    const params = new URLSearchParams(window.location.search);
    const one = params.get('pc_pref1');
    const two = params.get('pc_pref2');
    if (!permitted.includes(one)) return;
    const root = document.querySelector('#mon-prefere [data-pc-mix-favorite]');
    if (!root || root.dataset.pcLinkPrefilled === 'true') return;
    const picker = root.querySelector('[data-mix-favorite]');
    if (!picker) return;
    const multi = permitted.includes(two);
    const target = multi ? 'several' : one;
    if (!Array.from(picker.options).some(option => option.value === target)) return;
    picker.value = target;
    root.querySelectorAll('[data-mix-favorite-result]').forEach(result => {
      result.hidden = result.dataset.mixFavoriteResult !== target;
    });
    picker.dispatchEvent(new Event('change', { bubbles: true }));
    if (multi) {
      const form = root.querySelector('[data-pc-duo]');
      const selects = form ? Array.from(form.querySelectorAll('[data-pc-duo-select]')) : [];
      if (selects.length === 2) {
        const format = params.get('pc_format');
        const preferredFormat = ['grain','moulu'].includes(format) ? format : 'grain';
        [one, two].forEach((coffee, i) => {
          const options = Array.from(selects[i].options).filter(option =>
            option.dataset.cafe === coffee && !option.disabled
          );
          const matching = options.find(option => option.dataset.format === preferredFormat) || options[0];
          if (matching) {
            selects[i].value = matching.value;
            selects[i].dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    }
    root.dataset.pcLinkPrefilled = 'true';
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCoffeePreferences, { once: true });
  } else {
    applyCoffeePreferences();
  }
  document.addEventListener('shopify:section:load', applyCoffeePreferences);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pc-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pc-navigation')) {
    customElements.define('pc-navigation', class extends HTMLElement {
      connectedCallback() {
        this.classList.add('pcnav-js');
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.toggleButton = this.querySelector('.pcnav-menu-toggle');
        this.panels = Array.from(this.querySelectorAll('.pcnav-dropdown'));
        this.media = window.matchMedia('(max-width: 1099px)');
        const coffees = this.querySelector('.pcnav-coffees');
        if (coffees) {
          const coffeeTrigger = coffees.querySelector('summary');
          let coffeeOpenTimer = 0;
          let coffeeCloseTimer = 0;
          const isDesktop = () => !this.media.matches;
          coffees.addEventListener('pointerenter', event => {
            if (!isDesktop() || event.pointerType === 'touch') return;
            clearTimeout(coffeeCloseTimer);
            clearTimeout(coffeeOpenTimer);
            if (coffees.open) return;
            coffeeOpenTimer = setTimeout(() => {
              this.panels.forEach(other => { if (other !== coffees) other.open = false; });
              coffees.open = true;
            }, 300);
          }, {signal});
          coffees.addEventListener('pointerleave', () => {
            if (!isDesktop()) return;
            clearTimeout(coffeeOpenTimer);
            clearTimeout(coffeeCloseTimer);
            coffeeCloseTimer = setTimeout(() => { coffees.open = false; }, 350);
          }, {signal});
          coffeeTrigger.addEventListener('click', event => {
            if (!isDesktop()) return;
            event.preventDefault();
            window.location.href = '/pages/nos-cafes';
          }, {signal});
          coffeeTrigger.addEventListener('focus', () => {
            if (!isDesktop()) return;
            clearTimeout(coffeeOpenTimer);
            coffees.open = true;
          }, {signal});
          signal.addEventListener('abort', () => {
            clearTimeout(coffeeOpenTimer);
            clearTimeout(coffeeCloseTimer);
          }, {once:true});
        }
        this.reveal = () => this.setAttribute('data-revealed', '');
        this.reveal();
        document.addEventListener('pointermove', this.reveal, {once:true, passive:true, signal});
        document.addEventListener('pointerdown', this.reveal, {once:true, passive:true, signal});
        document.addEventListener('keydown', this.reveal, {once:true, signal});
        this.addEventListener('focusin', this.reveal, {signal});
        window.addEventListener('scroll', () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {this.scrollFrame=0;this.updateScroll();});
        }, {passive:true, signal});
        window.addEventListener('pageshow', () => this.updateScroll(), {signal});
        this.toggleButton.addEventListener('click', () => this.toggleMenu(), {signal});
        this.querySelector('.pcnav-backdrop')?.addEventListener('click', () => this.closeMenu(), {signal});
        this.addEventListener('keydown', event => this.keyHandler(event), {signal});
        this.addEventListener('click', event => {
          if (event.target.closest('a')) this.closeMenu(false);
        }, {capture:true, signal});
        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target)) this.closePanels();
        }, {signal});
        this.panels.forEach(panel => {
          panel.addEventListener('toggle', () => {
            if (panel.open) this.panels.forEach(other => { if (other !== panel) other.open = false; });
          }, {signal});
        });
        this.media.addEventListener('change', () => {this.closeMenu(false);this.updateScroll();this.updateSize();}, {signal});
        window.addEventListener('resize', () => this.updateSize(), {passive:true, signal});
        this.resizeObserver = new ResizeObserver(() => this.updateSize());
        this.resizeObserver.observe(this.querySelector('.pcnav-bar'));
        this.updateScroll();
        this.updateSize();
      }
      updateScroll() {
        const compact = this.hasAttribute('data-compact') ? window.scrollY > 24 : window.scrollY > 64;
        this.toggleAttribute('data-compact',compact);
        if(window.scrollY > 8)this.reveal();
        this.updateSize();
      }
      updateSize() {
        const box = this.querySelector('.pcnav-bar').getBoundingClientRect();
        this.style.setProperty('--pcnav-bottom', `${Math.max(0,box.bottom)}px`);
        document.documentElement.style.setProperty('--pcnav-scroll-offset', `${Math.ceil(box.bottom) + 16}px`);
        document.documentElement.style.setProperty('--header-height', `${this.media.matches ? Math.ceil(box.height) : 192}px`);
        this.querySelectorAll('[data-coffee-anchor]').forEach(link => {
          link.hash = `${window.innerWidth <= 749 ? 'pcm' : 'pc'}-${link.dataset.coffeeAnchor}`;
        });
      }
      toggleMenu() {
        if(this.hasAttribute('data-open')) {this.closeMenu();return;}
        this.updateSize();
        this.setAttribute('data-open','');
        if (this.media.matches) {
          const coffeePanel = this.querySelector('.pcnav-coffees');
          if (coffeePanel) coffeePanel.open = true;
          const drawer = this.querySelector('.pcnav-body');
          if (drawer) drawer.scrollTop = 0;
        }
        this.setAttribute('role','dialog');
        this.setAttribute('aria-modal','true');
        this.setAttribute('aria-label',this.dataset.menuLabel);
        this.toggleButton.setAttribute('aria-expanded','true');
        this.toggleButton.setAttribute('aria-label',this.dataset.closeLabel);
        document.body.classList.add('pcnav-scroll-lock');
        this.inertNodes=[];
        let branch=this;
        while(branch.parentElement && branch.parentElement !== document.documentElement) {
          Array.from(branch.parentElement.children).forEach(node => {
            if(node!==branch && !node.inert && !['SCRIPT','STYLE','LINK'].includes(node.tagName)) {node.inert=true;this.inertNodes.push(node);}
          });
          branch=branch.parentElement;
        }
        this.querySelector('.pcnav-coffees > summary').focus();
      }
      closePanels() {this.panels?.forEach(panel => {panel.open=false;});}
      closeMenu(restoreFocus=true) {
        const wasOpen=this.hasAttribute('data-open');
        this.removeAttribute('data-open');
        this.removeAttribute('role');this.removeAttribute('aria-modal');this.removeAttribute('aria-label');
        this.toggleButton?.setAttribute('aria-expanded','false');
        this.toggleButton?.setAttribute('aria-label',this.dataset.openLabel);
        document.body.classList.remove('pcnav-scroll-lock');
        this.inertNodes?.forEach(node => {node.inert=false;});this.inertNodes=[];
        this.closePanels();
        if(wasOpen && restoreFocus) this.toggleButton.focus();
      }
      keyHandler(event) {
        if(event.key==='Escape') {
          const openPanel=this.panels.find(panel=>panel.open);
          if(openPanel) {openPanel.open=false;openPanel.querySelector('summary').focus();}
          else if(this.hasAttribute('data-open')) this.closeMenu();
          event.preventDefault();return;
        }
        if(event.key!=='Tab'||!this.hasAttribute('data-open')) return;
        const focusable=Array.from(this.querySelectorAll('a[href],button,summary,input')).filter(el=>el.getClientRects().length && !el.disabled);
        const first=focusable[0], last=focusable[focusable.length-1];
        if(event.shiftKey && document.activeElement===first) {last.focus();event.preventDefault();}
        else if(!event.shiftKey && document.activeElement===last) {first.focus();event.preventDefault();}
      }
      disconnectedCallback() {this.closeMenu(false);this.abort?.abort();this.resizeObserver?.disconnect();cancelAnimationFrame(this.scrollFrame);}
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pc-pro-experience"] && !Shopify.designMode) return;
  try {
    (() => {
'use strict';
const init = root => {
 if (root.dataset.pcProReady === 'true') return;
 root.dataset.pcProReady = 'true';
 if (root.dataset.pcProPage === 'hub') return;
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const tabGroups = [];
root.querySelectorAll('[data-tabs]').forEach(group => {
 const tabs = [...group.querySelectorAll('[data-tab]')];
 const panels = [...group.querySelectorAll('[data-panel]')];
 if (!tabs.length || tabs.length !== panels.length) return;
 group.querySelector('.experience-tabs').setAttribute('role', 'tablist');
 const activate = (id, animate = true) => {
  if (!panels.some(panel => panel.id === id)) return;
  tabs.forEach(tab => {
   const selected = tab.getAttribute('href') === '#' + id;
   tab.setAttribute('role', 'tab');
   tab.setAttribute('aria-controls', tab.getAttribute('href').slice(1));
   tab.setAttribute('aria-selected', String(selected));
   tab.tabIndex = selected ? 0 : -1;
  });
  panels.forEach((panel, i) => {
   panel.setAttribute('role', 'tabpanel');
   panel.setAttribute('aria-labelledby', tabs[i].id);
   panel.tabIndex = 0;
   panel.hidden = panel.id !== id;
   panel.classList.remove('is-entering');
   if (!panel.hidden && animate && !reduceMotion.matches) panel.classList.add('is-entering');
  });
 };
 tabs.forEach((tab, index) => {
  tab.addEventListener('click', event => {
   event.preventDefault();
   activate(tab.getAttribute('href').slice(1));
  });
  tab.addEventListener('keydown', event => {
   let target;
   const vertical = group.querySelector('.experience-tabs').getAttribute('aria-orientation') === 'vertical';
   if (event.key === 'ArrowRight' || (vertical && event.key === 'ArrowDown')) target = (index + 1) % tabs.length;
   else if (event.key === 'ArrowLeft' || (vertical && event.key === 'ArrowUp')) target = (index + tabs.length - 1) % tabs.length;
   else if (event.key === 'Home') target = 0;
   else if (event.key === 'End') target = tabs.length - 1;
   else return;
   event.preventDefault();
   activate(tabs[target].getAttribute('href').slice(1));
   tabs[target].focus();
  });
 });
 activate(panels.some(panel => '#' + panel.id === location.hash) ? location.hash.slice(1) : panels[0].id, false);
 tabGroups.push({activate, panels});
});
const revealHashTarget = hash => {
 const match = tabGroups.find(group => group.panels.some(panel => '#' + panel.id === hash));
 if (match) match.activate(hash.slice(1));
};
root.querySelectorAll('a[href^="#"]:not([data-tab])').forEach(link => {
 link.addEventListener('click', () => revealHashTarget(link.getAttribute('href')));
});
window.addEventListener('hashchange', () => revealHashTarget(location.hash));

const form = root.querySelector('form.pc-pro-form');
let projectPrimary = '';
const selectedPoints = new Set();
const pointButtons = [...root.querySelectorAll('[data-add-point]')];
const renderProjectContext = () => {
 if (!form) return;
 const text = [projectPrimary, selectedPoints.size ? root.dataset.pcLabelPointsTitle + '\n' + [...selectedPoints].map(point => '• ' + point).join('\n') : ''].filter(Boolean).join('\n\n');
 form.querySelector('[data-project-context]').value = text;
 form.querySelector('[data-recap-text]').textContent = text;
 form.querySelector('.project-recap').hidden = !text;
 pointButtons.forEach(button => {
  const selected = selectedPoints.has(button.dataset.addPoint);
  button.setAttribute('aria-pressed', String(selected));
  button.querySelector('[data-point-label]').textContent = selected ? root.dataset.pcLabelPointSelected : root.dataset.pcLabelPointAdd;
  button.querySelector('[aria-hidden]').textContent = selected ? '✓' : '＋';
 });
 const status = root.querySelector('[data-question-status]');
 if (status) status.textContent = selectedPoints.size ? (selectedPoints.size === 1 ? root.dataset.pcLabelPointSingle : root.dataset.pcLabelPointPlural).replace('%count%', selectedPoints.size) : root.dataset.pcLabelPointEmpty;
};
const showProjectContext = text => {
 projectPrimary = text;
 renderProjectContext();
};
pointButtons.forEach(button => button.addEventListener('click', () => {
 const point = button.dataset.addPoint;
 if (selectedPoints.has(point)) selectedPoints.delete(point);
 else selectedPoints.add(point);
 renderProjectContext();
}));
root.querySelectorAll('[data-request-topic]').forEach(link => link.addEventListener('click', () => {
 selectedPoints.add(link.dataset.requestTopic);
 renderProjectContext();
}));
root.querySelector('[data-clear-recap]')?.addEventListener('click', () => {
 selectedPoints.clear();
 showProjectContext('');
 form.querySelector('[data-pc-name]').focus();
});
root.querySelectorAll('a[data-interest]').forEach(link => link.addEventListener('click', () => {
 const selection = form?.querySelector('[data-pc-solution]');
 if (selection) selection.value = link.dataset.interest;
 showProjectContext(root.dataset.pcLabelSolutionTitle + link.dataset.interest + '.');
}));
form?.querySelector('[data-pc-solution]')?.addEventListener('change', event => {
 if (!form.querySelector('.project-recap').hidden) showProjectContext(root.dataset.pcLabelSolutionTitle + event.target.value + '.');
});
root.querySelector('[data-diagnosis-contact]')?.addEventListener('click', () => {
 const selected = root.querySelector('[data-diagnosis] [data-panel]:not([hidden])');
 const size = root.querySelector('[data-diagnosis-size]').value;
 const effectif = form?.querySelector('[data-pc-effectif]');
 if (effectif && size) effectif.value = size;
 showProjectContext(root.dataset.pcLabelPriorityTitle + selected.dataset.priority + '.');
});

const progress = document.createElement('div');
progress.className = 'page-progress';
progress.setAttribute('aria-hidden', 'true');
root.append(progress);
let scrollQueued = false;
const updateProgress = () => {
 if (!root.isConnected) return;
 const distance = root.offsetHeight - window.innerHeight;
 const rootTop = root.getBoundingClientRect().top + window.scrollY;
 progress.style.transform = `scaleX(${distance > 0 ? Math.min(1, Math.max(0, (window.scrollY - rootTop) / distance)) : 0})`;
 scrollQueued = false;
};
window.addEventListener('scroll', () => {
 if (!scrollQueued) { scrollQueued = true; requestAnimationFrame(updateProgress); }
}, {passive:true});
window.addEventListener('resize', updateProgress);
updateProgress();
if (!reduceMotion.matches && 'IntersectionObserver' in window) {
 const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
   if (entry.isIntersecting) {
    entry.target.classList.remove('reveal-pending');
    entry.target.classList.add('reveal-ready');
    observer.unobserve(entry.target);
   }
  });
 }, {threshold:0.06});
 root.querySelectorAll('.section-head, .experience, .drink-card, .process, .coffee-minis, .support-photo').forEach(element => {
  if (element.getBoundingClientRect().top > window.innerHeight) {
   element.classList.add('reveal-pending');
   observer.observe(element);
  }
 });
 reduceMotion.addEventListener('change', event => {
  if (event.matches) {
   observer.disconnect();
   root.querySelectorAll('.reveal-pending').forEach(element => element.classList.remove('reveal-pending'));
  }
 });
}

const chapterLinks = [...root.querySelectorAll('[data-chapter]')];
const chapterTargets = chapterLinks.map(link => root.querySelector(link.getAttribute('href')));
let chapterQueued = false;
const updateChapters = () => {
 if (!root.isConnected) return;
 let active = 0;
 chapterTargets.forEach((section, index) => {
  if (section && section.getBoundingClientRect().top <= (parseFloat(getComputedStyle(root).getPropertyValue('--pc-pro-sticky-offset')) || 0) + 155) active = index;
 });
 chapterLinks.forEach((link, index) => {
  if (index === active) link.setAttribute('aria-current', 'location');
  else link.removeAttribute('aria-current');
 });
 chapterQueued = false;
};
if (chapterLinks.length) {
 window.addEventListener('scroll', () => {
  if (!chapterQueued) { chapterQueued = true; requestAnimationFrame(updateChapters); }
 }, {passive:true});
 window.addEventListener('resize', updateChapters);
 updateChapters();
}
};
const initAll = () => document.querySelectorAll('.pc-pro[data-pc-pro-page]').forEach(init);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, {once:true});
else initAll();
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.pc-pro[data-pc-pro-page]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pc-review-carousel-single"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pc-review-carousel')) {
    customElements.define('pc-review-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = {signal:this.controller.signal};
        this.slides = Array.from(this.querySelectorAll('[data-review-slide]'));
        this.index = 0;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.reduced.matches;
        this.hovered = false;
        this.classList.add('is-ready');
        this.show(0);
        if (this.slides.length < 2) return;
        this.querySelector('.pc-review-carousel__controls').hidden = false;
        this.toggleButton = this.querySelector('[data-review-pause]');
        this.querySelector('[data-review-prev]').addEventListener('click',()=>this.show(this.index-1,true),options);
        this.querySelector('[data-review-next]').addEventListener('click',()=>this.show(this.index+1,true),options);
        this.toggleButton.addEventListener('click',()=>{this.paused=!this.paused;this.sync();},options);
        this.addEventListener('pointerenter',()=>{this.hovered=true;this.sync();},options);
        this.addEventListener('pointerleave',()=>{this.hovered=false;this.sync();},options);
        this.addEventListener('focusin',(event)=>{if(event.target===this.toggleButton){clearInterval(this.timer);return;}this.paused=true;this.sync();},options);
        document.addEventListener('visibilitychange',()=>this.sync(),options);
        this.reduced.addEventListener('change',()=>{if(this.reduced.matches)this.paused=true;this.sync();},options);
        this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.sync();},{threshold:.2});
        this.observer.observe(this);
        this.sync();
      }
      show(index,manual=false) {
        this.index=(index+this.slides.length)%this.slides.length;
        this.slides.forEach((slide,i)=>{const active=i===this.index;slide.classList.toggle('is-current',active);slide.setAttribute('aria-hidden',String(!active));slide.inert=!active;});
        const position=this.querySelector('[data-review-position]');
        if(position)position.textContent=this.index+1;
        if(manual){this.paused=true;this.querySelector('.pc-review-carousel__status').textContent=(this.index+1)+' / '+this.slides.length;this.sync();}
      }
      sync() {
        clearInterval(this.timer);
        if(!this.toggleButton)return;
        this.toggleButton.setAttribute('aria-label',this.paused?this.dataset.playLabel:this.dataset.pauseLabel);
        this.toggleButton.firstElementChild.textContent=this.paused?'▶':'Ⅱ';
        if(!this.paused&&!this.hovered&&this.inView&&!document.hidden)this.timer=setInterval(()=>this.show(this.index+1),6000);
      }
      disconnectedCallback() {clearInterval(this.timer);this.observer?.disconnect();this.controller?.abort();this.controller=null;}
    });
  }
  } catch(e) { console.error(e); }
})();

})();
